/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import CallInbound from './call-inbound';
import CallOutbound from './call-outboundf';
import CallInProgress from './call-inprogress';
import { useLwp } from '../../hooks/use-lwp';

export default function CallControl(props: {}) {
  const {
    phoneState: { callStatus, callDirection, error }
  } = useLwp();

  return (
    <>
      {callStatus === 'initiating' && (callDirection === 'incoming' ? <CallInbound /> : <CallOutbound /> )}
      {callStatus === 'inprogress' && <CallInProgress />}
    </>
  );
}
